import { AspObject, ObjectType } from './AspObject';
import { IObjectsPool } from './interfaces';
import * as units from '../common/units';
import * as utils from '../common/utils';
import { userSettings } from '@core_n/common/settings';
import { Source } from '@core_n/common/enums';
import * as enums from '../common/enums';
import { SensorCoreObject } from './SensorCoreObject';
import { AppConfig } from '@core_n/app.config';
import { SensorObject } from 'src/app/asp/SensorObject';

export var ACOUSTIC_VECTOR_COUNT = 200;
export var ACOUSTIC_VECTOR_HISTORY_COUNT = 50;

export const ACOUSTIC_SYMBOL = "acoustic-line";
export const ACOUSTIC_SYMBOL_CSS = utils.getPlaneSymbol(ACOUSTIC_SYMBOL);

export class AcousticVector {
  public ID: any = 'aaa';
  public Angle: number = 0;
  public Lat: number = 0;
  public long: number = 0;
  public IsDelete: boolean = false;
  public isSim: boolean = false;
  public line: any;
  public lineColor: any;
  public text: any;
  public date: Date;
  public arrivalDate: Date;
  public f0: number;
  public MaxFreqEnergy: number;
  public source: Source;
  public SnsID: number;
  public snr: number;
  public cls: string;

  constructor() { };
  handleMsg(msgObj: any, snsObj: SensorCoreObject): boolean {
    this.ID = msgObj.targetId;
    this.Angle = (msgObj.azimuth * units.RAD_TO_DEG)  % 360;  
    this.date = new Date(msgObj.epochTime);
    this.arrivalDate = new Date();
    // this.isSim = msgObj.IsSim;
    // this.MaxFreqEnergy = msgObj.MaxFreqEnergy;
    // this.snr = msgObj.Snr;
    // if (msgObj.Source)
    //   this.source = enums.sourceStr2Num(msgObj.Source);
    // else
    this.source = 1;
    this.SnsID = snsObj.sensorID;
    this.cls = msgObj.CLS ?? "unknown";
    const distMeters = AppConfig.settings.params.azimuth?.sensor?.length ?? 3000; // meters
    let line = new NeWMI.Geometry.Polyline();
    const secondPoint = utils.newmiPointByRangeAzimuth(snsObj.geometry, distMeters, this.Angle, 0);
    
    line.points.push(new NeWMI.Geometry.Point({ x: snsObj.geometry.x, y: snsObj.geometry.y, z: snsObj.geometry.z })); // ellipse location
    line.points.push(secondPoint); // track location
    this.line = line;

    const colorScale = AppConfig.settings.colorScale;
    const color = colorScale[this.cls] ?? colorScale.unknown;
    this.lineColor = utils.cssColorToNewmi(color);
    let text = new NeWMI.Object.NeWMIObjectDM.TextOrSymbolDrawData();
    text.value = `ID: ${this.ID} \n${this.cls}`;
    text.location = { x: this.long, y: this.Lat };
    text.alignment = { horizontal: 'center', vertical: 'middle' };
    text.size = userSettings.symbolsSize;
    this.text = text;

    return true;
  }
}

export class AcousticVectorObject extends AspObject {
  public Data: AcousticVector = undefined;
  public HistoryOn: boolean = false;
  public HistoryDeleted: Boolean = true; // need to use this to determine if history needs to be deleted...
  public Selected: boolean = false;
  public History: Array<AcousticVector> = [];

  public SnsObject: SensorObject = undefined;

  constructor(objectsPool: IObjectsPool, objectType: ObjectType, public AcVecID: number, sns: SensorObject) {
    super(objectsPool, objectType, AspObject.generateId(objectType, AcVecID));
    this.SnsObject = sns;
  }

  handleMsg(msgObj: any): boolean {
    if (this.Data)
      this.History.push(this.Data);
    this.Data = msgObj;
    // this.updateDynamics(this.Data.long, this.Data.Lat, 300);
    this.notifyDataChange();

    this.geometry = this.Data.line;
    return true;
  }

  getTitle(): string {
    if (!this.isValid())
      return ``;
    return `Acoustic vector: ${this.Data.ID}`;
  }

  // getColor() {
  //   return this.newmiColor;
  // }

  getCssColor() {
    return utils.newmiColorToString(this.Data.lineColor);
  }

  getSymbol() {
    return ACOUSTIC_SYMBOL;
  }

  getSvgSymbol() {
    return ACOUSTIC_SYMBOL_CSS;
  }
}
